import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule, MatSelectionList } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';

import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkTableModule } from '@angular/cdk/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatDividerModule } from '@angular/material/divider';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PrismModule } from '@ngx-prism/core';
import { ChartsModule } from 'ng2-charts';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgxPaginationModule } from 'ngx-pagination';
import { MaterialTimePickerModule } from '@candidosales/material-time-picker';



@NgModule({
    imports: [
        CommonModule,
        MatToolbarModule,
        MatButtonModule,
        MatCardModule,
        MatInputModule,
        MatDialogModule,
        MatTableModule,
        CdkTableModule,
        CdkStepperModule,
        MatMenuModule,
        MatIconModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatButtonToggleModule,
        MatListModule,
        MatSelectModule,
        MatSidenavModule,
        MatStepperModule,
        MatBadgeModule,
        MatGridListModule,
        MatFormFieldModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatChipsModule,
        MatTooltipModule,
        MatPaginatorModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatTreeModule,
        MatSnackBarModule,
        MatTabsModule,
        MatExpansionModule,
        DragDropModule,
        MatDividerModule,
        FlexLayoutModule,
        MatCardModule,
        MatPaginatorModule,
        MatTableModule,
        MatTabsModule,

        MatDialogModule,
        PrismModule,
        ChartsModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule,
        MatSliderModule,
        MatSlideToggleModule,
        EditorModule,
        MatExpansionModule,
        NgxPaginationModule,
        MaterialTimePickerModule
    ],
    exports: [
        CommonModule,
        MatToolbarModule,
        MatButtonModule,
        MatCardModule,
        MatInputModule,
        MatDialogModule,
        MatTableModule,
        CdkTableModule,
        CdkStepperModule,
        MatMenuModule,
        MatIconModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatButtonToggleModule,
        MatListModule,
        MatSidenavModule,
        MatStepperModule,
        MatBadgeModule,
        MatGridListModule,
        MatFormFieldModule,
        MatSelectModule,
        MatRadioModule,
        MatDatepickerModule,
        MatChipsModule,
        MatTooltipModule,
        MatPaginatorModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatTreeModule,
        MatSnackBarModule,
        MatTabsModule,
        MatExpansionModule,
        DragDropModule,
        MatDividerModule,
        FlexLayoutModule,
        MatCardModule,
        MatPaginatorModule,
        MatTableModule,
        MatTabsModule,

        MatDialogModule,
        PrismModule,
        ChartsModule,
        MatFormFieldModule,
        MatInputModule,
        MatTooltipModule,
        MatSliderModule,
        MatSlideToggleModule,
        EditorModule,
        MatExpansionModule,
        NgxPaginationModule,
        MaterialTimePickerModule

    ],
})
export class CustomMaterialModule { }
